<template>
    <svg
        width="17"
        height="16"
        viewBox="0 0 17 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M8.50009 0C4.08185 0 0.5 3.58185 0.5 8.00009C0.5 12.4181 4.08185 16 8.50009 16C12.9181 16 16.5 12.4181 16.5 8.00009C16.5 3.58185 12.9181 0 8.50009 0ZM9.57361 10.8816C8.84822 11.7854 7.32189 12.5549 6.7293 12.5549C6.50706 12.5549 6.09224 12.3183 6.09224 12.0966C6.09224 12.08 6.09174 12.0666 6.09129 12.0546C6.08934 12.0021 6.0885 11.9797 6.13672 11.8587C6.30654 11.4435 6.46891 11.0598 6.63049 10.6781C6.97612 9.86149 7.31812 9.05348 7.72173 7.96253C7.76652 7.82987 7.73702 7.68176 7.60359 7.68176C7.44065 7.68176 7.05532 7.82956 6.68498 8.09659C6.61053 8.15558 6.47741 8.0518 6.47741 7.99265C6.47741 7.87326 6.53672 7.77057 6.65533 7.62246C6.98135 7.25196 8.43292 6.25938 9.36667 6.25938C9.52929 6.25938 9.73686 6.59944 9.73686 6.7335C9.73686 6.86616 9.63292 7.13288 9.57346 7.26694C9.1427 8.29053 8.88572 8.98232 8.64791 9.62252L8.64789 9.62257L8.64788 9.6226C8.49341 10.0384 8.34703 10.4325 8.16636 10.8816C8.10721 11.0445 8.2252 11.0879 8.32914 11.0879C8.46226 11.0879 8.86257 10.8961 9.41052 10.4078C9.5733 10.274 9.61793 10.2438 9.7072 10.2438C9.73655 10.2438 9.82519 10.2881 9.82519 10.3633C9.82535 10.481 9.73701 10.6887 9.57361 10.8816ZM8.86285 4.95551C8.9518 5.01482 9.08508 5.05945 9.2335 5.05945C9.78098 5.05945 10.2852 4.46687 10.2851 3.97838C10.2851 3.54764 10.0475 3.13281 9.48493 3.13281C9.36678 3.13281 9.17373 3.17729 8.99644 3.29731C8.74424 3.47429 8.49219 3.77097 8.49219 4.20015C8.49219 4.55536 8.66995 4.80741 8.86285 4.95551Z"
            fill="currentColor"
        />
    </svg>
</template>

<script>
import { defineComponent } from "vue";

export default defineComponent({
    name: "InfoIcon",
});
</script>
